module.exports = "/packs/step5-3bbd607d1cb7acbbc89a5b41fc6d69c0.png";